export class ErrorHandler{
    Writte<T>(msg:string, err:T){
        console.error(msg, err);
    }
}

export default new ErrorHandler();

